import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  DivisionalPromotionExpansionClickData,
  DivisionalPromotionEventData,
  DivisionalPromotionProductClickData,
  DivisionalPromotionSortingClickData,
  SellerShowcaseDivisionalPromotion,
} from '@app/seller-showcase/models/seller-showcase.model';
import { PlatformService } from '@panamax/app-state';
import { SortableSectionHeader } from '@shared/components/sortable-section/models/sortable-section.model';

@Component({
  selector: 'app-seller-showcase-divisional-promotions',
  templateUrl: './seller-showcase-divisional-promotions.component.html',
  styleUrls: ['./seller-showcase-divisional-promotions.component.scss'],
})
export class SellerShowcaseDivisionalPromotionsComponent {
  @Input() divisionalPromotions: SellerShowcaseDivisionalPromotion[];
  @Input() sectionHeaders: SortableSectionHeader[];
  @Input() isOnline: boolean;
  @Input() filtersApplied: number;
  @Input() pricingDisabled: boolean;
  @Input() allProductsAvailable: boolean;

  @Output()
  clearAllClickEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  filterClickEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  updateExpansionEventEmitter: EventEmitter<DivisionalPromotionExpansionClickData> =
    new EventEmitter();
  @Output()
  updateSortEventEmitter: EventEmitter<DivisionalPromotionSortingClickData> =
    new EventEmitter();
  @Output()
  ellipsisClickEmitter: EventEmitter<DivisionalPromotionProductClickData> =
    new EventEmitter();
  @Output()
  promotionalProductClickEmitter: EventEmitter<DivisionalPromotionProductClickData> =
    new EventEmitter();
  @Output()
  searchWithinEmitter: EventEmitter<string> = new EventEmitter();
  @Output() changeQuantityEmitter =
    new EventEmitter<DivisionalPromotionEventData>();

  searchWithinKey: string;
  searchWithinDebounceTime = 500;

  constructor(readonly platformService: PlatformService) {}

  handleUpdateExpansionEvent(event: DivisionalPromotionExpansionClickData) {
    this.updateExpansionEventEmitter.emit(event);
  }

  handleUpdateSortEvent(event: any) {
    this.updateSortEventEmitter.emit(event);
  }

  handleEllipsisClick(event: DivisionalPromotionProductClickData) {
    this.ellipsisClickEmitter.emit(event);
  }

  handleProductClick(event: DivisionalPromotionProductClickData) {
    this.promotionalProductClickEmitter.emit(event);
  }

  resetSearchWithin() {
    this.searchWithinKey = '';
    this.searchWithin();
  }

  searchWithin() {
    this.searchWithinEmitter.emit(this.searchWithinKey);
  }

  handleOpenFilterModal() {
    this.filterClickEmitter.emit();
  }

  handleClearAllFilters() {
    this.clearAllClickEmitter.emit();
  }

  handleQuantityChange(event: DivisionalPromotionEventData) {
    this.changeQuantityEmitter.emit(event);
  }

  trackBySort = (index: number, promotion: SellerShowcaseDivisionalPromotion) =>
    `${index}-${promotion?.promotionName}-${promotion?.sortBy?.headerName}-${promotion?.sortBy?.sortDirection}`;
}
